<template>
  <CCol col="12" xl="12" class="p-0">
    <CCard class="p-0">
      <CCardHeader
        class="d-flex justify-content-between align-items-center bg-secondary"
      >
        <h5 class="text-light m-0 p-0">هشدارها</h5>

        <CRow>
          <CInput
            placeholder="جستجو..."
            class="py-0 px-2 m-0 col-11"
            style="direction: ltr"
            v-model="search"
            :value="search"
            @input="quickSearch(search)"
          >
            <template #prepend>
              <download-excel
                :data="filteredInfo.length > 0 ? filteredInfo : alarm"
                :fields="alarmExl"
              >
                <CButton color="warning" class="mx-1"
                  ><i class="fa fa-file-excel-o" aria-hidden="true"></i
                ></CButton>
              </download-excel>
              <CButton
                color="success"
                @click="setFinishAllAlarm()"
                class="mx-1"
              >
                اتمام همه
                <CIcon name="cil-check-circle" />
              </CButton>
              <CButton color="info" @click="quickSearch(search)">
                <CIcon name="cil-search" />
              </CButton>
            </template>
          </CInput>
        </CRow>
      </CCardHeader>

      <CCard class="my-2 p-0">
        <CButton
          block
          class="text-right shadow-none card-header"
          @click="showFilter = showFilter === 6 ? false : 6"
        >
          <h5 class="text-primary">فیلتر</h5>
        </CButton>
        <CCollapse :show="showFilter === 6">
          <CCardBody>
            <CRow>
              <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                <label class="typo__label">وضعیت آلارم</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.state"
                  :options="stateList"
                  :allowEmpty="false"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                ></multiselect>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                <label class="typo__label">نوع آلارم</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.alarmType"
                  :options="alarmTypeList"
                  :allowEmpty="false"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                ></multiselect></div
            ></CRow>
            <CRow>
              <date-picker
                placeholder="از تاریخ"
                class="col-sm-12 col-md-6 col-lg-4"
                v-model="info.fromDate"
                :value="info.fromDate"
              >
              </date-picker>
              <date-picker
                placeholder="تا تاریخ"
                class="col-sm-12 col-md-6 col-lg-4"
                v-model="info.toDate"
                :value="info.toDate"
              >
              </date-picker>
              <v-jstree
                class="my-2"
                :data="structureList"
                show-checkbox
                allow-batch
                whole-row
                noDots
                allow-empty
                @item-click="itemClick"
              ></v-jstree>

              <div
                class="col-sm-12 col-md-6 col-lg-4 form-group"
                v-if="deviceList.length > 0"
              >
                <label class="typo__label">دستگاه ها</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.device"
                  :options="deviceList"
                  :allowEmpty="true"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                  :multiple="true"
                  @input="updateSensorList()"
                ></multiselect>
              </div>

              <div
                class="col-sm-12 col-md-6 col-lg-4 form-group"
                v-if="sensorList.length > 0"
              >
                <label class="typo__label">سنسور ها</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.sensor"
                  :options="sensorList"
                  :allowEmpty="true"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                  :multiple="true"
                ></multiselect>
              </div>
            </CRow>
            <CRow>
              <CButton
                @click="getAlarms()"
                class="mt-4 mb-3 btn-success col-sm-12 col-md-6 col-lg-6"
                ><CIcon
                  name="cil-check-circle"
                  class="text-light align-self-center"
              /></CButton>
              <CButton
                @click="clearSearchItem()"
                class="mt-4 mb-3 btn-danger col-sm-12 col-md-6 col-lg-6"
                ><CIcon
                  name="cil-loop-circular"
                  class="text-light align-self-center"
                />
              </CButton>
            </CRow>
          </CCardBody>
        </CCollapse>
      </CCard>

      <div>
        <!-- <div
          v-for="(item, i) in filteredInfo.length > 0 ? filteredInfo : alarm"
          :key="i"
        > -->
        <div v-for="(item, i) in paginatedItems" :key="i">
          <CRow class="m-2 px-2 pt-3 rounded border-danger">
            <CRow v-if="item.alarmType == 1">
              <p class="text-dark col">
                <span class="text-secondary">دستگاه:</span>
                {{ item.deviceName }}
              </p>
              <p class="text-dark col">
                <span class="text-secondary">سنسور:</span>
                {{ item.sensorTypeName + " " + item.sensorIndex }}
              </p>
              <p class="text-dark col">
                <span class="text-secondary">مقدار:</span>
                {{ item.startValue1 }}
              </p>
              <p class="text-dark col">{{ item.startTime }}</p>
            </CRow>

            <CRow v-else-if="item.alarmType == 2">
              <p class="text-dark col">
                <span class="text-secondary">دستگاه:</span>
                {{ item.deviceName }}
              </p>
              <p class="text-dark col">
                <span class="text-secondary">محدودیت مکانی</span>
              </p>
              <p class="text-dark col">
                <CButton
                  class="p-0, m-0"
                  @click="
                    showMap(item.startValue1, item.startValue2, item.deviceId)
                  "
                  >مشاهده</CButton
                >
              </p>
              <p class="text-dark col">{{ item.startTime }}</p>
            </CRow>

            <CRow v-else-if="item.alarmType == 3">
              <p class="text-dark col">
                <span class="text-secondary">دستگاه:</span>
                {{ item.deviceName }}
              </p>
              <p class="text-dark col">
                <span class="text-secondary">محدودیت سرعت</span>
              </p>
              <p class="text-dark col">
                <span class="text-secondary">سرعت:</span> {{ item.startValue1 }}
              </p>
              <p class="text-dark col">{{ item.startTime }}</p>
            </CRow>

            <CRow v-else-if="item.alarmType == 4">
              <p class="text-dark col">
                <span class="text-secondary">دستگاه:</span>
                {{ item.deviceName }}
              </p>
              <p class="text-dark col">
                <span class="text-secondary">سرویس دوره‌ای</span>
              </p>
              <p class="text-dark col">
                <!-- <span class="text-secondary">سرعت:</span> {{ item.startValue1 }} -->
              </p>
              <p class="text-dark col">{{ item.startTime }}</p>
            </CRow>

             <CRow v-else-if="item.alarmType == 5">
              <p class="text-dark col">
                <span class="text-secondary">دستگاه:</span>
                {{ item.deviceName }}
              </p>
              <p class="text-dark col">
                <span class="text-secondary">تغییر وضعیت</span>
              </p>
              <p class="text-dark col">
                <!-- <span class="text-secondary">سرعت:</span> {{ item.startValue1 }} -->
              </p>
              <p class="text-dark col">{{ item.startTime }}</p>
            </CRow>

            <CTextarea
              class="col-sm-12 text-dark"
              :value="item.description"
              disabled
            />

            <CRow class="justify-content-center mt-2">
              <CButton
                v-if="item.alarmType == 4"
                :disabled="!item.state"
                @click="setFinishService(item.periodicRepairsId)"
                color="success"
                class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                ><CIcon name="cil-check-circle" class="mx-1" />دوره
                بعدی</CButton
              >
              <CButton
                v-else
                :disabled="!item.state"
                @click="setFinishAlarm(item.activeAlarmId)"
                color="success"
                class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                ><CIcon name="cil-check-circle" class="mx-1" />اتمام</CButton
              >

              <!-- <CButton
              @click="showAlarmHistory(item)"
              color="primary"
              class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
              ><CIcon name="cil-clock" class="mx-1" />تاریخچه</CButton
            > -->
              <!-- <CButton
              @click="sendAlarmToUsers(item)"
              color="info"
              class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
              ><CIcon name="cil-user" class="mx-1" />ارجاع</CButton
            > -->
              <CButton
                @click="
                  showAlarmMessage(item.activeAlarmId);
                  showSendMessage = item.state;
                "
                color="warning"
                class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                ><CIcon name="cil-list" class="mx-1" />رهگیری</CButton
              >
              <!-- <CButton
                    @click="refreshDeviceSetting('wifi')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
            </CRow>
          </CRow>
          <!-- <CRow
          class="m-2 px-2 pt-3 rounded"
          style="background-color: #ff5733"
          v-else-if="item.message == 2"
        >
          <CRow>
            <p class="text-white col">
              <span class="text-dark">دستگاه:</span> {{ item.deviceName }}
            </p>
            <p class="text-white col">
              <span class="text-dark">سنسور:</span> {{ item.sensorName }}
            </p>
            <p class="text-white col">
              <span class="text-dark">مقدار:</span> {{ item.sensorValue }}
            </p></CRow
          >

          <CTextarea
            disabled
            class="col-sm-12 text-dark"
            label="متن هشدار"
            type="password"
            required
            value="مقدار سنسور از آستانه بیشینه تجاوز نموده است."
          />

          <p class="text-white text-center">{{ item.dateTime }}</p>
        </CRow> -->
        </div>
        <nav aria-label="Page navigation">
          <ul class="pagination justify-content-center">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
              <a class="page-link" href="#" @click="goToPage(1)">صفحه اول</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
              <a class="page-link" href="#" @click="previousPage">صفحه قبل</a>
            </li>

            <span class="m-2">{{ currentPage }}/{{ totalPages }}</span>
            <!-- <li
              class="page-item"
              v-for="page in totalPages"
              :key="page"
              :class="{ active: page === currentPage }"
            >
              <a class="page-link" href="#" @click="goToPage(page)">{{
                page
              }}</a>
            </li> -->
            <li
              class="page-item"
              :class="{ disabled: currentPage === totalPages }"
            >
              <a class="page-link" href="#" @click="nextPage">صفحه بعد</a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: currentPage === totalPages }"
            >
              <a class="page-link" href="#" @click="goToPage(totalPages)"
                >صفحه آخر</a
              >
            </li>
          </ul>
        </nav>
      </div>
    </CCard>
    <!-- ----------------------------------------------------- send alarm to user modal -->
    <CModal title="ارجاع آلارم" :show.sync="sendModal" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <CForm class="needs-validation" novalidate>
        <!-- <h5 class="text-primary mb-3">اطلاعات محدودیت</h5>
        <hr /> -->

        <CRow>
          <div class="col-sm-12 col-md-6 col-lg-4 form-group">
            <label class="typo__label">کاربر</label>
            <multiselect
              class="needs-validation"
              v-model="sendUder.user"
              :options="userList"
              :allow-empty="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="انتخاب..."
              label="label"
              track-by="value"
            ></multiselect>
          </div>

          <CTextarea
            class="col-12"
            label="شرح ارجاع"
            required
            rows="5"
            v-model="sendUder.command"
            :value="sendUder.command"
          />
        </CRow>
      </CForm>

      <template #footer>
        <CButton
          @click="sendMessage()"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />ارسال</CButton
        >
        <CButton
          @click="sendModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />بازگشت</CButton
        >
      </template>

      <!-- <template #footer>
        <CButton
          @click="addModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />لغو</CButton
        >
        <CButton
          @click="submitForm"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ modalButtonSubmit }}</CButton
        >
      </template> -->
    </CModal>

    <!-- ----------------------------------------------------- show alarm message modal -->
    <CModal title="پیام های آلارم" :show.sync="alarmMessageModal" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <CForm class="needs-validation p-0 m-0" novalidate>
        <!-- <h5 class="text-primary mb-3">اطلاعات محدودیت</h5>
        <hr /> -->

        <CRow
          v-for="(item, i) in alarmMessages"
          :key="i"
          class="p-1 rounded mt-1"
        >
          <CRow class="m-0 rounded col-12 border-danger">
            <p class="text-dark col mt-2">
              <span class="text-secondary">پیام از:</span> {{ item.userName1 }}
              <span class="text-secondary">به:</span> {{ item.userName2 }}
            </p>
            <p class="text-dark col mt-2">
              <span class="text-secondary">علت آلارم:</span> {{ item.reason }}
            </p>
            <p class="text-dark col mt-2">
              <span class="text-secondary">تاریخ ارسال:</span>
              {{ item.dateSend }}
            </p>
            <p class="text-dark col mt-2">
              <span class="text-secondary">تاریخ مشاهده:</span>
              {{ item.dateView == null ? "مشاهده نشده" : item.dateView }}
            </p>
            <CTextarea
              disabled
              class="col-sm-12 text-dark"
              :value="item.referralOrder"
            />
          </CRow>

          <!-- <CRow class="m-1 rounded col-12" style="background-color: #e59866">
            <p class="text-white col mt-2">
              <span class="text-dark">گیرنده:</span> {{ item.receiver }}
            </p>
            <p class="text-white col mt-2">
              <span class="text-dark">تاریخ:</span> {{ item.receiverDateTime }}
            </p>
            <CTextarea
              class="col-sm-12 text-dark"
              :value="'پاسخ: ' + item.receiverMessage"
            />
          </CRow> -->
        </CRow>
      </CForm>

      <template #footer>
        <!-- <CButton
          @click="alarmMessageModal = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />ارسال</CButton
        > -->
        <!-- <CButton
          @click="alarmMessageModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />بازگشت</CButton
        > -->
        <CAlert color="warning" closeButton :show.sync="alert" class="col-12">
          {{ alertText }}
        </CAlert>
        <CForm class="needs-validation col-12" novalidate>
          <!-- <h5 class="text-primary mb-3">اطلاعات محدودیت</h5>
        <hr /> -->

          <CRow v-if="showSendMessage">
            <div class="col-sm-12 col-md-6 col-lg-4 form-group">
              <label class="typo__label">کاربر</label>
              <multiselect
                class="needs-validation"
                v-model="sendUder.user"
                :options="userList"
                :allow-empty="false"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                placeholder="انتخاب..."
                label="label"
                track-by="value"
              ></multiselect>
            </div>

            <div class="col-sm-12 col-md-6 col-lg-4 form-group">
              <label class="typo__label">علت آلارم</label>
              <multiselect
                class="needs-validation"
                v-model="sendUder.alarmReason"
                :options="reasonAlarmList"
                :allow-empty="false"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                placeholder="انتخاب..."
                label="label"
                track-by="value"
              ></multiselect>
            </div>

            <CTextarea
              class="col-12"
              label="شرح ارجاع"
              required
              rows="5"
              v-model="sendUder.command"
              :value="sendUder.command"
            />
          </CRow>
          <CButton
            v-if="showSendMessage"
            @click="sendMessage()"
            color="success"
            class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
            ><CIcon name="cil-check-circle" />ارسال</CButton
          >
          <CButton
            @click="alarmMessageModal = false"
            color="danger"
            class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
            ><CIcon name="cil-ban" />بازگشت</CButton
          >
        </CForm>
      </template>

      <!-- <template #footer>
        <CButton
          @click="addModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />لغو</CButton
        >
        <CButton
          @click="submitForm"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ modalButtonSubmit }}</CButton
        >
      </template> -->
    </CModal>

    <!-- ----------------------------------------------------- show alarm history modal -->
    <CModal title="تاریخچه آلارم" :show.sync="alarmHistoryModal" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <CForm class="needs-validation p-0 m-0" novalidate>
        <div v-for="(item, i) in alarmHistory" :key="i">
          <CRow class="m-2 px-2 pt-3 rounded" style="background-color: #ff5733">
            <CRow v-if="item.alarmType == 1">
              <p class="text-white col">
                <span class="text-dark">دستگاه:</span> {{ item.deviceName }}
              </p>
              <p class="text-white col">
                <span class="text-dark">سنسور:</span>
                {{ item.sensorTypeName + " " + item.sensorIndex }}
              </p>
              <p class="text-white col">
                <span class="text-dark">مقدار:</span> {{ item.value1 }}
              </p>
              <p class="text-white col">{{ item.alarmTime }}</p>
            </CRow>

            <CRow v-else-if="item.alarmType == 2">
              <p class="text-white col">
                <span class="text-dark">دستگاه:</span> {{ item.deviceName }}
              </p>
              <p class="text-white col">
                <span class="text-dark">محدودیت مکانی</span>
              </p>
              <p class="text-white col">
                <CButton
                  class="p-0, m-0"
                  @click="showMap(item.value1, item.value2, item.deviceId)"
                  >مشاهده</CButton
                >
              </p>
              <p class="text-white col">{{ item.alarmTime }}</p>
            </CRow>

            <CRow v-else-if="item.alarmType == 3">
              <p class="text-white col">
                <span class="text-dark">دستگاه:</span> {{ item.deviceName }}
              </p>
              <p class="text-white col">
                <span class="text-dark">محدودیت سرعت</span>
              </p>
              <p class="text-white col">
                <span class="text-dark">سرعت:</span> {{ item.value1 }}
              </p>
              <p class="text-white col">{{ item.alarmTime }}</p>
            </CRow>
          </CRow>
        </div>
      </CForm>

      <template #footer>
        <!-- <CButton
          @click="alarmMessageModal = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />ارسال</CButton
        > -->
        <CButton
          @click="alarmHistoryModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />بازگشت</CButton
        >
      </template>
    </CModal>

    <CModal
      :title="alertModalTitle"
      :color="alertModalColor"
      :show.sync="alertModal"
    >
      {{ alertModalText }}

      <template #footer>
        <CButton
          v-if="alertModalTitle != 'حذف اداره'"
          @click="alertModal = false"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
      </template>
    </CModal>
  </CCol>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import axios from "axios";
import { Values } from "../../../src/commonValues";
import VJstree from "vue-jstree-master"; //rtl

import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import { eventBus } from "../../main.js";

export default {
  components: { datePicker: VuePersianDatetimePicker, VJstree },

  data() {
    return {
      totalPages: "",
      totalItems: "",
      paginatedItems: "",
      items: [], // Your list of items
      currentPage: 1,
      pageSize: 100, // Number of items per page

      alarmExl: {
        Id: "activeAlarmId",
        "نام دستگاه": "deviceName",
        "نام نوع سنسور": "sensorTypeName",
        "نوع سنسور": "sensorType",
        "اندیس سنسور": "sensorIndex",
        "مقدار شروع اول": "startValue1",
        "مقدار شروع دوم": "startValue2",
        "مقدار اتمام اول": "endValue1",
        "مقدار اتمام دوم": "endValue2",
        "مقدار فعلی اول": "currentValue1",
        "مقدار فعلی دوم": "currentValue2",
        "نام نوع آلارم": "alarmTypeName",
        "نوع آلارم": "alarmType",
        "زمان شروع": "startTime",
        "زمان اتمام": "endTime",
        "آخرین بروزرسانی": "lastUpdate",
        توضیح: "description",
        "شماره دستگاه": "deviceId",
        وضعیت: "state",
        //"شماره سازمان":"organizationId",
        //"Id":"periodicRepairsId",
        //"Id":"alarmKind",
        //"Id":"alarmStatus"
      },

      alarmMessages: [
        // {
        //   sender: "ناصر شامی",
        //   sendDateTime: "1401/02/25 23:25:10",
        //   senderMessage: "لطفا خطا بررسی شود",
        //   receiver: "امیرعطا امیرخانی",
        //   receiverDateTime: "1401/02/26 07:25:10",
        //   receiverMessage: "خطا رفع شد",
        // },
        // {
        //   sender: "ناصر شامی",
        //   sendDateTime: "1401/02/26 20:25:10",
        //   senderMessage: "لطفا خطا سرویس بررسی شود",
        //   receiver: "سعید اسمعیلی",
        //   receiverDateTime: "1401/02/26 23:25:10",
        //   receiverMessage: "خطا رفع شد",
        // },
      ],

      alert: false,
      alertText: "",
      showSendMessage: true,

      sendUder: { command: "", user: [] ,alarmReason:[]},

      userList: [
        // { label: "LPTO", value: "1" },
        // { label: "HPTO", value: "10" },
        // { label: "HPTH", value: "11" },
      ],

      reasonAlarmList: [
        { label: "باز بودن درب", value: "باز بودن درب" },
        { label: "خرابی تجهیز", value:  "خرابی تجهیز" },
        { label: "برفک زدایی", value:"برفک زدایی" },
        { label: "گذاشتن نمونه در تجهیز", value: "گذاشتن نمونه در تجهیز" },
        { label: "قطع شدن سرور", value: "قطع شدن سرور" },
        { label: "قطع شبکه", value: "قطع شبکه" },
        { label: "اصلاح چیدمان اقلام", value: "اصلاح چیدمان اقلام" },
        { label: "چک آلارم", value: "چک آلارم" },
        { label: "سایر", value: "سایر" },
      ],

      sendModal: false,
      alarmMessageModal: false,
      showFilter: 0,
      alarmHistoryModal: false,

      alarmHistory: [],

      structureList: [],
      selectedParent: 0,

      info: {
        ModelValue: [],
        status: [],
        device: [],
        sensor: [],
        fromDate: "",
        toDate: "",
        state: { label: "فعال", value: true },
        alarmType: { label: "همه", value: 0 },
        organizationId: 0,
      },

      stateList: [
        { label: "فعال", value: true },
        { label: "غیرفعال", value: false },
      ],

      alarmTypeList: [
        { label: "همه", value: 0 },
        { label: "سنسور", value: 1 },
        { label: "محدوده", value: 2 },
        { label: "سرعت", value: 3 },
        { label: "تعمیر و نگهداری", value: 4 },
        { label: "تغییر وضعیت", value: 5 },
      ],

      sensorList: [],
      deviceList: [],

      filteredInfo: [],
      alarm: [
        // {
        //   carName: "سردخانه کرمانشاه",
        //   sensorName: "دما و رطوبت شماره 1",
        //   sensorValue: "25.36",
        //   carPermissionName: "1",
        //   dateTime: "1400/08/26 13:21:33",
        // },
        // {
        //   carName: "سالن قارچ گانودرما",
        //   sensorName: "دما و رطوبت شماره 2",
        //   sensorValue: "28.36",
        //   carPermissionName: "2",
        //   dateTime: "1400/08/25 13:21:35",
        // },
        // {
        //   carName: "سردخانه کرمانشاه",
        //   sensorName: "دما و رطوبت شماره 1",
        //   sensorValue: "25.36",
        //   carPermissionName: "1",
        //   dateTime: "1400/08/25 13:21:38",
        // },
        // {
        //   carName: "سالن قارچ گانودرما",
        //   sensorName: "دما و رطوبت شماره 2",
        //   sensorValue: "28.36",
        //   carPermissionName: "2",
        //   dateTime: "1400/08/25 13:21:23",
        // },
      ],

      date: "",
      search: "",

      alertModal: false,
      alertModalTitle: "",
      alertModalText: "",
      alertModalButtonText: "",
      alertModalColor: "",
      alarmIdToSendMessage: "",
    };
  },

  computed: {},
  mounted() {
    // axios.get(Values.serverIp + "Alarm/Alarms").then((response) => {
    //   console.log(response.data);
    //   this.alarm = response.data;
    //   //if (this.alarm.length > 0) this.sendSeenAlarms();
    //   if (this.alarm.length == 0) {
    //     this.alertModal = true;
    //     this.alertModalTitle = "آلارم";
    //     this.alertModalText = "آلارم فعالی موجود نمی باشد.";
    //     (this.alertModalColor = "info"), (this.alertModalButtonText = "تایید");
    //   }
    // });

    this.getAlarms();

    //this.GetOrganizationalStructureTree();
    this.GetOrganizationalStructureTreePerUser();
  },

  methods: {
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        this.paginatedItems =
          this.filteredInfo.length > 0
            ? this.filteredInfo.slice(startIndex, endIndex)
            : this.alarm.slice(startIndex, endIndex);
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        this.paginatedItems =
          this.filteredInfo.length > 0
            ? this.filteredInfo.slice(startIndex, endIndex)
            : this.alarm.slice(startIndex, endIndex);
      }
    },
    goToPage(page) {
      this.currentPage = page;
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      this.paginatedItems =
        this.filteredInfo.length > 0
          ? this.filteredInfo.slice(startIndex, endIndex)
          : this.alarm.slice(startIndex, endIndex);
    },

    setFinishAllAlarm() {
      var tempAlarm = [];
      var alarmF =
        this.filteredInfo.length > 0 ? this.filteredInfo : this.alarm;
      for (var i = 0; i < alarmF.length; i++) {
        tempAlarm.push(alarmF[i].activeAlarmId);
      }

      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "Alarm/CompletionAllAlarmsAsync",
          tempAlarm,
          config
        )
        .then((response) => {
          if (response.status == 200) {
            if (response.status == 200) {
              this.alertModal = true;
              this.alertModalTitle = "آلارم";
              this.alertModalText =
                "آلارم های انتخاب شده ازحالت فعال خارج شدند.";
              (this.alertModalColor = "info"),
                (this.alertModalButtonText = "تایید");
            }
            this.getAlarms();
          }
        })
        .catch((response) => {
          console.log(response);
          if (response.response.status == 403) {
            // do not have permission
            // modal unsuccessful edit change
            (this.alertModal = true),
              // (this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          }
        });
    },
    //***************************************************************************** get alarms */
    getAlarms() {
      var tempDevice = [];
      for (var i = 0; i < this.info.device.length; i++) {
        tempDevice.push(this.info.device[i].value);
      }

      var tempSensor = [];
      for (var i = 0; i < this.info.sensor.length; i++) {
        tempSensor.push(this.info.sensor[i].value);
      }

      axios
        .post(Values.serverIp + "Alarm/Alarms", {
          state: this.info.state.value,
          fromDate: this.info.fromDate,
          toDate: this.info.toDate,
          organizationId: this.selectedParent, //this.info.organizationId,
          deviceLevelList: tempDevice,
          sensorLevelList: tempSensor,
          alarmType: this.info.alarmType.value,
        })
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data);
            this.alarm = response.data;

            if (this.info.state.value == true)
              eventBus.$emit("changeAlarmNum", response.data.length);

            //********************* pagination */
            this.totalItems =
              this.filteredInfo.length > 0
                ? this.filteredInfo.length
                : this.alarm.length;

            this.totalPages = Math.ceil(this.totalItems / this.pageSize);
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.paginatedItems =
              this.filteredInfo.length > 0
                ? this.filteredInfo.slice(startIndex, endIndex)
                : this.alarm.slice(startIndex, endIndex);
          }
        })
        .catch((response) => {
          console.log(response);
          if (response.response.status == 403) {
            // do not have permission
            // modal unsuccessful edit change
            (this.alertModal = true),
              // (this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          }
        });
    },
    //********************************************************************* get organiztion tree  per user*/
    GetOrganizationalStructureTreePerUser() {
      axios
        .get(
          Values.serverIp +
            "OrganizationalStructure/GetOrganizationalStructureTreeForUser"
        )
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);
            this.structureList = response.data;
            this.deviceList = [];
            this.sensorList = [];
            this.info.device = [];
            this.info.sensor = [];
            this.GetUserDeviceAccessPermission(false);
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },
    //****************************************************************** select parrent */
    itemClick(node) {
      this.selectedParent = node.model.id;

      this.deviceList = [];
      this.sensorList = [];
      this.info.device = [];
      this.info.sensor = [];
      this.GetDeviceLevelSelectListForUser(node.model.id);
    },

    //********************************************************************* get organiztion tree  per user*/
    GetUserDeviceAccessPermission(data) {
      axios
        .get(Values.serverIp + "User/GetUserDeviceAccessPermission")
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);
            if (data == false) {
              if (response.data.organizationId != 0) {
                this.GetDeviceLevelSelectListForUser(
                  response.data.organizationId
                );
              }
            } else {
              this.GetDeviceLevelSelectListForUser(
                response.data.organizationId
              );
            }

            //this.structureList = response.data;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },
    //********************************************************************* get device per user*/
    GetDeviceLevelSelectListForUser(data) {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp +
            "UserDeviceAccessPermission/GetDeviceLevelSelectListForUser",
          JSON.stringify(data),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);
            this.deviceList = response.data;
            // if (whichView == "view") this.viewAction(actionData);
            // else if (whichView == "edit") this.editAction(actionData);
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "2خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* end alarm to users */
    sendAlarmToUsers(data) {
      this.getUserList();
      this.sendModal = true;
      this.alarmIdToSendMessage = data.activeAlarmId;
      this.sendUder.user = [];
      this.sendUder.alarmReason=[];
      this.sendUder.command = "";
    },

    //********************************************************************* how Alarm Message */
    showAlarmMessage(data) {
      this.getUserList();
      this.alarmIdToSendMessage = data;
      this.sendUder.user = [];
      this.sendUder.alarmReason=[];
      this.sendUder.command = "";
      this.alarmMessageModal = true;

      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "alarm/GetAlarmsTrackingForAlarmActive",
          data,
          config
        )
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data);
            this.alarmMessages = response.data;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* show Alarm History */
    showAlarmHistory(data) {
      this.alarmIdToSendMessage = data.activeAlarmId;
      this.alarmHistoryModal = true;

      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "alarm/GetAlarmActiveHistory",
          data.activeAlarmId,
          config
        )
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data);
            this.alarmHistory = response.data;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },
    //********************************************************************* get organiztion tree */
    // GetOrganizationalStructureTree() {
    //   const config = { headers: { "Content-Type": "application/json" } };
    //   axios
    //     .post(
    //       Values.serverIp +
    //         "OrganizationalStructure/GetOrganizationalStructureTree",
    //       JSON.stringify(""),
    //       config
    //     )
    //     .then((response) => {
    //       if (response.status == 200) {
    //         //console.log(response.data);
    //         this.structureList = response.data;
    //       } else {
    //         // modal unsuccessful edit change
    //         (this.alertModal = true),
    //           (this.alertModalTitle = "خطایی رخ داده"),
    //           (this.alertModalText =
    //             "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
    //           (this.alertModalColor = "danger"),
    //           (this.alertModalButtonText = "تایید");
    //       }
    //     })
    //     .catch((response) => {
    //       if (response.status != 200) {
    //         // modal unsuccessful edit change
    //         this.alertModal = true;
    //         this.alertModalTitle = "خطایی رخ داده";
    //         this.alertModalText =
    //           "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
    //         (this.alertModalColor = "info"),
    //           (this.alertModalButtonText = "تایید");
    //       }
    //     });
    // },

    // //****************************************************************** select parrent */
    // itemClick(node) {
    //   this.selectedParent = node.model.id;
    //   //console.log(this.selectedParent);
    //   this.getDeviceByOrganazionId(node.model.id, 0);
    // },

    // //***************************************************************** getDeviceByOrganazionId */
    // getDeviceByOrganazionId(data, read, selectedDevice, selectedSensor) {
    //   this.deviceList = [];
    //   this.info.device = [];
    //   this.sensorList = [];
    //   this.info.sensor = [];
    //   const config = { headers: { "Content-Type": "application/json" } };
    //   axios
    //     .post(
    //       Values.serverIp +
    //         "UserDeviceAccessPermission/GetDeviceLevelSelectList",
    //       JSON.stringify(data),
    //       config
    //     )
    //     .then((response) => {
    //       if (response.status == 200) {
    //         this.deviceList = response.data;
    //         // if (read == 1) {
    //         //   for (var i = 0; i < this.deviceList.length; i++) {
    //         //     for (var j = 0; j < selectedDevice.length; j++) {
    //         //       if (selectedDevice[j] == this.deviceList[i].value)
    //         //         this.userInfo.device.push(this.deviceList[i]);
    //         //     }
    //         //   }

    //         //   this.updateSensorList(1, selectedSensor);
    //         // }
    //       }
    //     })
    //     .catch((response) => {
    //       //console.log("in catch");
    //       if (response.response.status == 403) {
    //         // do not have permission
    //         // modal unsuccessful edit change
    //         (this.alertModal = true),
    //           // (this.showPage = false),
    //           (this.alertModalTitle = "عدم مجوز"),
    //           (this.alertModalText =
    //             "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
    //           (this.alertModalColor = "info"),
    //           (this.alertModalButtonText = "تایید");
    //       } else {
    //         this.alertModal = true;
    //         this.alertModalTitle = "خطایی رخ داده";
    //         this.alertModalText =
    //           "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
    //         this.alertModalColor = "danger";
    //         this.alertModalButtonText = "تایید";
    //       }
    //     });
    // },
    // ************************************************************** updata Sensor List
    updateSensorList(read, selectedSensor) {
      if (this.info.device.length > 0) {
        this.sensorList = [];
        this.info.sensor = [];
        let temp = [];
        for (var i = 0; i < this.info.device.length; i++) {
          temp.push(this.info.device[i].value);
        }
        //UserDeviceAccessPermission/GetSensorLevelSelectListForUser
        axios
          .post(
            Values.serverIp +
              "UserDeviceAccessPermission/GetSensorLevelSelectListForUser",
            {
              organizationId: this.selectedParent,
              deviceIds: temp,
            }
          )
          .then((response) => {
            if (response.status == 200) {
              this.sensorList = response.data;
              if (read == 1) {
                for (var i = 0; i < this.sensorList.length; i++) {
                  for (var j = 0; j < selectedSensor.length; j++) {
                    if (selectedSensor[j] == this.sensorList[i].value)
                      this.userInfo.sensor.push(this.sensorList[i]);
                  }
                }
              }
            }
          })
          .catch((response) => {
            //console.log("in catch");
            if (response.response.status == 403) {
              // do not have permission
              // modal unsuccessful edit change
              (this.alertModal = true),
                // (this.showPage = false),
                (this.alertModalTitle = "عدم مجوز"),
                (this.alertModalText =
                  "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
                (this.alertModalColor = "info"),
                (this.alertModalButtonText = "تایید");
            } else {
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
              this.alertModalColor = "danger";
              this.alertModalButtonText = "تایید";
            }
          });
      } else {
        this.sensorList = [];
        this.info.sensor = [];
      }
    },
    //*************************************************************** clear filter item */
    clearSearchItem() {
      this.info.device = [];
      this.info.sensor = [];
      this.info.ModelValue = [];
      this.info.status = [];
      this.selectedParent = 0;
      this.sensorList = [];
      this.deviceList = [];
      //this.GetOrganizationalStructureTree();
      this.GetOrganizationalStructureTreePerUser();
      this.info.fromDate = "";
      this.info.toDate = "";
      this.info.alarmType = { label: "همه", value: 0 };
      this.info.state = { label: "فعال", value: true };
    },
    // ****************************************************** alarm History
    alarmHistory() {
      //console.log(this.date);
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "Alert/AlertsByDate",
          this.date,

          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.info = response.data;
            if (this.info.length == 0) {
              this.alertModal = true;
              this.alertModalTitle = "آلارم";
              this.alertModalText =
                "برای تاریخ انتخاب شده آلارمی موجود نمی باشد.";
              (this.alertModalColor = "info"),
                (this.alertModalButtonText = "تایید");
            }
          }
        })
        .catch((response) => {});
    },

    //******************************************************** quick Search*/
    quickSearch(data) {
      if (data.length > 0) {
        this.filteredInfo = this.alarm.filter(function (el) {
          return (
            el.deviceName.includes(data) ||
            el.description.includes(data) ||
            el.startTime.includes(data) ||
            el.sensorTypeName.includes(data)
          );
        });
      } else {
        this.filteredInfo = [];
      }

      //console.log(data.length);
    },
    //******************************************************** send alarms seen */
    sendSeenAlarms() {
      let tempIds = [];
      for (let i = 0; i < this.alarm.length; i++)
        tempIds.push(this.alarm[i].alertId);

      //console.log(tempIds);

      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "alert/AlertsSeen",
          {
            alertIdList: tempIds,
          },
          config
        )
        .then((response) => {
          if (response.status == 200) {
            //console.log("seen Alarm");
          }
        })
        .catch((response) => {});
    },

    //************************************************************* set finish active alarm */
    setFinishAlarm(data) {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(Values.serverIp + "Alarm/CompletionOfAlarmsAsync", data, config)
        .then((response) => {
          if (response.status == 200) {
            this.alertModal = true;
            this.alertModalTitle = "آلارم";
            this.alertModalText = "آلارم ازحالت فعال خارج شد.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
          this.getAlarms();

          // console.log(Values.numOfAlarms);
        })
        .catch((response) => {});
    },

    //************************************************************* set finish active alarm */
    setFinishService(data) {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "PeriodicRepairs/UpdateNextPeriodicRepairs",
          data,
          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.alertModal = true;
            this.alertModalTitle = "سرویس دوره‌ای";
            this.alertModalText = "سرویس دوره بعد  فعال شد.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {});
    },

    //************************************************************* show map */]
    showMap(lat, lng, deviceId) {
      //console.log(lat, lng);
      let routeData = this.$router.resolve({
        name: "StopLocation",
        query: {
          //deviceId: data.deviceId,

          lat: lat,
          lng: lng,
          showLimit: 1,
          deviceId: deviceId,
        },
      });
      window.open(routeData.href, "_blank");
    },

    //************************************************************* send message */
    sendMessage() {
      if (this.sendUder.user.length < 1 || this.sendUder.alarmReason.length<1) {
        this.alert = true;
        this.alertText = "کاربر و علت آلارم باید انتخاب شوند.";
      } else {
        axios
          .post(Values.serverIp + "Alarm/CreateAlarmsTrackingAsync", {
            activeAlarmId: this.alarmIdToSendMessage,
            userId2: this.sendUder.user.value,
            referralOrder: this.sendUder.command,
            reason:this.sendUder.alarmReason.value,
          })
          .then((response) => {
            console.log(response);
            if (response.status == 200) {
              // (this.showPage = false),
              if (response.data == 0) {
                (this.sendModal = false),
                  ((this.alertModal = true),
                  (this.alertModalTitle = "ارسال پیام")),
                  (this.alertModalText = "پیام با موفقیت ارسال شد."),
                  (this.alertModalColor = "info"),
                  (this.alertModalButtonText = "تایید");
                this.showAlarmMessage(this.alarmIdToSendMessage);
              } else {
                (this.alertModal = true),
                  (this.alertModalTitle = "ارسال پیام"),
                  (this.alertModalText =
                    "خطا در ارسال پیام!!! لطفا مجدا تلاش فرمایید."),
                  (this.alertModalColor = "danger"),
                  (this.alertModalButtonText = "تایید");
              }
            }
          })
          .catch((response) => {
            //console.log("in catch");
            if (response.status == 403) {
              // do not have permission
              // modal unsuccessful edit change
              (this.alertModal = true),
                // (this.showPage = false),
                (this.alertModalTitle = "عدم مجوز"),
                (this.alertModalText =
                  "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
                (this.alertModalColor = "info"),
                (this.alertModalButtonText = "تایید");
            } else {
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
              this.alertModalColor = "danger";
              this.alertModalButtonText = "تایید";
            }
          });
      }
    },

    //*************************************************************************** get user list */
    getUserList() {
      axios
        .get(Values.serverIp + "user/GetUserDeviceAccessPermissionSelectList")
        .then((response) => {
          console.log(response.data);
          this.userList = response.data;
        });
    },
  },
};
</script>

<style>
</style>